import styled from "styled-components";
import COLORS from "../../Theme/Colors";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 900;
  display: ${(props) => (props.visible ? "block" : "none")};
  backdrop-filter: blur(20px);
`;

export const CenteredContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  .drop-anim {
    animation: drop 3s infinite;
  }

  @keyframes drop {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-30px);
    }
    60% {
      transform: translateY(-15px);
    }
  }
`;

export const GiftButton = styled.button`
  font-size: 50px;
  cursor: pointer;
  background-color: ${COLORS.blue};
  color: ${COLORS.white};
  border: none;
  border-radius: 20px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${COLORS.darkblue};
  }
`;

export const ConfettiContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 999;
`;
